import React from "react";
import Header from "./Components/Header";
import { CLASS_BOOKING } from "../../assets/asset";
import SessionCard from "./Components/SessionCard";
import PageContainer from "./Components/PageContainer";
import MainContent from "./Components/MainContent";
import BackButton from "./Components/BackButton";
import SectionTitle from "./Components/SectionTitle";

const MyBookings = () => {
  const upcomingSessions = [
    {
      id: 1,
      tutor: "Sarah Mitchell",
      image: "https://i.pravatar.cc/100?img=47",
      date: "Friday, 12 December, 2025",
      time: "4:00 PM",
      student: "Emma Wilson",
      status: "Upcoming",
    },
    {
      id: 2,
      tutor: "David Chen",
      image: "https://i.pravatar.cc/100?img=49",
      date: "Sunday, 15 December, 2025",
      time: "2:00 PM",
      student: "Emma Wilson",
      status: "Upcoming",
    },
  ];

  const pastSessions = [
    {
      id: 3,
      tutor: "Emma Thompson",
      image: "https://i.pravatar.cc/100?img=50",
      date: "Friday, 10 November, 2025",
      time: "3:00 PM",
      student: "Emma Wilson",
      status: "Completed",
    },
    {
      id: 4,
      tutor: "John Parker",
      image: "https://i.pravatar.cc/100?img=51",
      date: "Monday, 4 November, 2025",
      time: "11:00 AM",
      student: "Emma Wilson",
      status: "Completed",
    },
  ];

  return (
    <PageContainer>
      <div className="sticky top-0 z-50 bg-[#DFF2EB]/70 backdrop-blur-md">
        <Header />
      </div>

      <MainContent>
        <BackButton onClick={() => window.history.back()} label="Back to Dashboard" />
        
        <SectionTitle 
          title="My Bookings" 
          subtitle="Manage your tutoring sessions" 
        />

        <h3 className="text-lg font-semibold text-gray-800 mb-3">
          Upcoming Sessions ({upcomingSessions.length})
        </h3>

        <div className="flex flex-col gap-6 mb-10">
          {upcomingSessions.map((session) => (
            <SessionCard key={session.id} session={session} />
          ))}
        </div>

        <h3 className="text-lg font-semibold text-gray-800 mb-3">
          Past Sessions ({pastSessions.length})
        </h3>

        <div className="flex flex-col gap-6">
          {pastSessions.map((session) => (
            <SessionCard key={session.id} session={session} />
          ))}
        </div>
      </MainContent>
    </PageContainer>
  );
};

export default MyBookings;